import { Link } from "react-router-dom";
import CustomButton from "../../components/customButton";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { scrollToTop } from "../../lib/utils";

const Transporteur = () => {
  const { t } = useTranslation()
  useEffect(() => {
    scrollToTop()
  }, [])
  return (
    <div className="pt-10 h-full w-full bg-softGrey flex flex-col gap-5 items-center">
      <h2 className="text-[27px] font-normal">{t("recherche_transporteur")}</h2>
      <div className="p-4 flex flex-col gap-4 w-full max-w-[427px] bg-white rounded-[4px] items-center">
        <span className="text-grey font-normal text-[11px]">
          {t("besoin_transporteur")}
        </span>
        <div className="w-full flex flex-col gap-2">
          <label className="text-[13px]" htmlFor="">{t("ville_livraison")}?</label>
          <input
            className="h-[46px] rounded-[5px] placeholder:text-grey px-3 text-xs font-normal w-full min-w-[90px] bg-[#F5F5F5]  border-none focus:outline-none focus:ring-0 focus:border-transparent"

          />
        </div>
        <div className="w-full flex flex-col gap-2">
          <label className="text-[13px]" htmlFor="">{t("destination")}</label>
          <input
            className="h-[46px] rounded-[5px] placeholder:text-grey px-3 text-xs font-normal w-full min-w-[90px] bg-[#F5F5F5]  border-none focus:outline-none focus:ring-0 focus:border-transparent"

          />
        </div>
        <div className="w-full flex flex-col gap-2">
          <label className="text-[13px]" htmlFor="">{t("prix_estime")}</label>
          <input
            className="h-[46px] rounded-[5px] placeholder:text-grey px-3 text-xs font-normal w-full min-w-[90px] bg-[#F5F5F5]  border-none focus:outline-none focus:ring-0 focus:border-transparent"

          />
        </div>
        <div className="w-full flex justify-between items-center text-[11px]">
          <CustomButton className="px-2 py-2 bg-third">
            <span>{t("attacher_commande")}</span>
          </CustomButton>
          <CustomButton className="bg-white flex gap-2 px-2 py-2">
            <img src="/red.svg" alt="" />
            <span>{t("ajout_produit")}</span>
          </CustomButton>
        </div>
        <CustomButton className="bg-primary text-white px-6 py-2 max-w-[265px]" rounded>

          <Link className="text-[11px]" to={"/transporteurs_request"}>{t("envoyer_commande")}</Link>
        </CustomButton>
      </div>
    </div>
  );
};
export default Transporteur;
